import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  Link,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import VerifiedIcon from '@mui/icons-material/Verified'
import DownloadIcon from '@mui/icons-material/Download'
import InputMask from 'react-input-mask'
import Programa from '../../../components/Programa/Programa'
import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { metodoPrograma } from '../../../components/api'

const ValidadorDocumento = () => {
  const { cdValidacao } = useParams()
  const [cdCpf, setCdCpf] = useState('')
  const [solicitacao, setSolicitacao] = useState({})
  const [carregando, setCarregando] = useState(false)

  const agora = new Date()

  const baixarArquivo = useCallback(async () => {
    setCarregando(true)
    const obj = {
      cdValidacao,
      cdCpf: cdCpf ? cdCpf.replace(/[\s.-]/g, '') : undefined,
    }

    const res = await metodoPrograma('geraRelatorio', obj)

    if (res.status) {
      const base64 = res.base64

      const cleanBase64 = base64.includes('base64,')
        ? base64.split('base64,')[1]
        : base64

      const byteCharacters = atob(cleanBase64)
      const byteNumbers = new Array(byteCharacters.length)

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      const blob = new Blob([byteArray], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)

      window.open(url, '_blank')
    }
    setCarregando(false)
  }, [cdValidacao, cdCpf])

  const getDadosDocumento = useCallback(async () => {
    setCarregando(true)
    const obj = {
      cdValidacao,
    }

    const res = await metodoPrograma('valida', obj)

    if (res.status) {
      setSolicitacao({
        fileName: 'receita_medica.pdf',
        fileExists: true,
        userName: res.assinadoPor,
        fileDate: res.dtAssinatura,
        fileIsDigitallySigned: res.valido,
        signingDate: res.dtAssinatura,
        signedBy: res.assinadoPor,
        issuedBy: res.emitidoPor,
        validDate: res.validoAte,
        validationSummary: res.valido
          ? 'Assinatura válida'
          : 'Assinatura inválida',
      })
    }
    setCarregando(false)
  }, [cdValidacao])

  useEffect(() => {
    if (cdValidacao) {
      getDadosDocumento()
    }
  }, [getDadosDocumento, cdValidacao])

  return (
    <Programa
      codigo="CtrlValidaReceitaPublico"
      habTrocaLocal={false}
      habTitle={false}
    >
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={carregando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        sx={{
          minHeight: '100vh',
          background: '#f5f5f5',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          p: 2,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: '100%',
            maxWidth: 900,
            borderRadius: 3,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              background: '#00264c',
              color: '#fff',
              p: 3,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Box
              component="img"
              src="/logos/logo3SyncSemFundo.png"
              alt="Logo"
              style={{ marginTop: 30 }}
              sx={{
                width: 250,
                display: 'block',
                mx: 'auto',
                mb: 1,
              }}
            />

            <Typography
              variant="h5"
              fontWeight="bold"
              style={{ marginTop: 40 }}
            >
              Validador de Documento
            </Typography>

            <Typography variant="body2" mt={1}>
              Verificação de autenticidade e assinatura digital
            </Typography>
          </Box>

          <CardContent sx={{ p: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Data e hora: {agora.toLocaleString('pt-BR')}
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>
                  <strong>Nome do arquivo:</strong> {solicitacao.fileName}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography>
                  <strong>Arquivo existente:</strong>{' '}
                  {solicitacao.fileExists ? 'Sim' : 'Não'}
                </Typography>
              </Grid>

              {solicitacao.fileExists && (
                <>
                  <Grid item xs={12}>
                    <Typography>
                      <strong>Criado por:</strong> {solicitacao.signedBy}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography>
                      <strong>Data de criação:</strong>{' '}
                      {solicitacao.signingDate}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography>
                      <strong>Assinado digitalmente:</strong>{' '}
                      {solicitacao.fileIsDigitallySigned ? 'Sim' : 'Não'}
                    </Typography>
                  </Grid>

                  {solicitacao.fileIsDigitallySigned && (
                    <>
                      <Grid item xs={12}>
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            background: '#fafafa',
                          }}
                        >
                          <CardContent>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                xs={12}
                                md={2}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                              >
                                <VerifiedIcon
                                  color="success"
                                  sx={{ fontSize: 80 }}
                                />
                              </Grid>

                              <Grid item xs={12} md={10}>
                                <Typography
                                  variant="h6"
                                  fontWeight="bold"
                                  gutterBottom
                                >
                                  Assinatura Digital {solicitacao.signedBy}
                                </Typography>

                                <Typography>
                                  <strong>Assinado em:</strong>{' '}
                                  {solicitacao.signingDate.toLocaleString(
                                    'pt-BR',
                                  )}
                                </Typography>

                                <Typography>
                                  <strong>Assinado por:</strong>{' '}
                                  {solicitacao.signedBy}
                                </Typography>

                                <Typography>
                                  <strong>Certificado emitido por:</strong>{' '}
                                  {solicitacao.issuedBy}
                                </Typography>

                                <Typography>
                                  <strong>Certificado válido até:</strong>{' '}
                                  {solicitacao.validDate.toLocaleString(
                                    'pt-BR',
                                  )}
                                </Typography>

                                <Typography>
                                  <strong>Validação:</strong>{' '}
                                  {solicitacao.validationSummary}
                                </Typography>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>

                      <Grid item xs={12}>
                        <Divider sx={{ my: 1 }} />
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant="h6" fontWeight="bold" gutterBottom>
                          Download de Documento
                        </Typography>

                        <Typography variant="body2" mb={2}>
                          Para validar este documento junto ao ITI, informe o
                          CPF do paciente.
                        </Typography>

                        <Grid container spacing={2}>
                          <Grid item xs={12} md={8}>
                            <InputMask
                              mask="999.999.999-99"
                              onChange={(e) => setCdCpf(e.target.value)}
                            >
                              {() => (
                                <TextField
                                  InputLabelProps={{ shrink: true }}
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  margin="dense"
                                  label="CPF"
                                />
                              )}
                            </InputMask>
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <Button
                              fullWidth
                              variant="contained"
                              color="primary"
                              startIcon={<DownloadIcon />}
                              sx={{ height: '100%' }}
                              onClick={baixarArquivo}
                            >
                              Fazer Download
                            </Button>
                          </Grid>
                        </Grid>

                        <Box mt={2}>
                          <Link
                            href="https://validar.iti.gov.br"
                            target="_blank"
                            underline="hover"
                          >
                            validar.iti.gov.br
                          </Link>
                        </Box>
                      </Grid>
                    </>
                  )}
                </>
              )}
            </Grid>
          </CardContent>
        </Paper>
      </Box>
    </Programa>
  )
}

export default ValidadorDocumento
